import { Component, OnInit, Inject, ViewChild } from '@angular/core';



@Component({
    selector: 'app-emergency-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss']
})
export class EmergencyChartComponent implements OnInit {

    constructor() { }

    ngOnInit() {

       
    }   

}

